<template>
<div class="kt-portlet__body" :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        is_fit: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.is_fit === true) {
                _class.push('kt-portlet__body--fit')
            }

            return _class
        }
    }
}
</script>